/**
 * Constants
 * 
 * Shared constants used throughout the Swagger Auth library.
 * 
 * @module Constants
 */

/**
 * Global CSS styles for notifications
 * 
 * These styles should be injected into the document head when the first
 * notification is displayed. They provide a modern, polished toast UI.
 */
export const NOTIFICATION_STYLES = `
    .swagger-auth-notification-container {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 10000;
        pointer-events: none;
    }
    
    .swagger-auth-notification {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 300px;
        max-width: 500px;
        padding: 12px 16px;
        margin-bottom: 12px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        pointer-events: all;
        opacity: 0;
        transform: translateX(400px);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }
    
    .swagger-auth-notification-show {
        opacity: 1;
        transform: translateX(0);
    }
    
    .swagger-auth-notification-hide {
        opacity: 0;
        transform: translateX(400px);
    }
    
    .swagger-auth-notification-icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
    }
    
    .swagger-auth-notification-icon svg {
        width: 16px;
        height: 16px;
    }
    
    .swagger-auth-notification-content {
        flex: 1;
        min-width: 0;
    }
    
    .swagger-auth-notification-title {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 2px;
        color: #1f2937;
    }
    
    .swagger-auth-notification-message {
        font-size: 13px;
        color: #4b5563;
        word-wrap: break-word;
    }
    
    .swagger-auth-notification-action {
        flex-shrink: 0;
        padding: 4px 12px;
        font-size: 13px;
        font-weight: 500;
        border: none;
        background: transparent;
        cursor: pointer;
        border-radius: 4px;
        transition: background-color 0.2s;
    }
    
    .swagger-auth-notification-action:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
    
    .swagger-auth-notification-close {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        padding: 0;
        border: none;
        background: transparent;
        cursor: pointer;
        color: #9ca3af;
        font-size: 18px;
        line-height: 1;
        transition: color 0.2s;
    }
    
    .swagger-auth-notification-close:hover {
        color: #4b5563;
    }
    
    /* Success */
    .swagger-auth-notification-success .swagger-auth-notification-icon {
        background-color: #d1fae5;
        color: #059669;
    }
    
    .swagger-auth-notification-success .swagger-auth-notification-action {
        color: #059669;
    }
    
    /* Error */
    .swagger-auth-notification-error .swagger-auth-notification-icon {
        background-color: #fee2e2;
        color: #dc2626;
    }
    
    .swagger-auth-notification-error .swagger-auth-notification-action {
        color: #dc2626;
    }
    
    /* Warning */
    .swagger-auth-notification-warning .swagger-auth-notification-icon {
        background-color: #fef3c7;
        color: #d97706;
    }
    
    .swagger-auth-notification-warning .swagger-auth-notification-action {
        color: #d97706;
    }
    
    /* Info */
    .swagger-auth-notification-info .swagger-auth-notification-icon {
        background-color: #dbeafe;
        color: #2563eb;
    }
    
    .swagger-auth-notification-info .swagger-auth-notification-action {
        color: #2563eb;
    }
    
    /* Progress bar */
    .swagger-auth-notification-progress {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3px;
        background-color: currentColor;
        opacity: 0.3;
        transition: width linear;
    }
    
    .swagger-auth-notification-success .swagger-auth-notification-progress {
        color: #059669;
    }
    
    .swagger-auth-notification-error .swagger-auth-notification-progress {
        color: #dc2626;
    }
    
    .swagger-auth-notification-warning .swagger-auth-notification-progress {
        color: #d97706;
    }
    
    .swagger-auth-notification-info .swagger-auth-notification-progress {
        color: #2563eb;
    }
`;
